import { TEXT_CATEGORY } from '@hive/status'
import { formatTextMaterialCategoryStatus } from './formatters/textMaterial'
import { GQL_ID } from '@@partner:types:graphql'
import { TEXT_MATERIAL_STORAGE_KEY } from '@@partner:config/storage'
import { TextMaterialFormState } from '@components/textMaterials/textMaterial/TextMaterialFormState'

export const getSearchableTextMaterialStatus = ()  => {
  const SEARCHABLE_TEXT_MATERIAL_CATEGORY_STATUS = [
    TEXT_CATEGORY.ACTIVE,
    TEXT_CATEGORY.DISABLED,
    TEXT_CATEGORY.HIDDEN
  ]

  return SEARCHABLE_TEXT_MATERIAL_CATEGORY_STATUS.map((status) => {
    const statusConfig = formatTextMaterialCategoryStatus(status)

    return {
      value: status,
      label: statusConfig.label,
      color: statusConfig.color
    }
  })
} 

function dateReviver (key: any, value: any) {
  // Например, если значение похоже на ISO-дату
  const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/
  if (typeof value === 'string' && dateRegex.test(value)) {
    return new Date(value)
  }
  return value
}

export const loadDraft = (id: GQL_ID | undefined, asString?: boolean): TextMaterialFormState => {
  const draft = localStorage.getItem(`${TEXT_MATERIAL_STORAGE_KEY}-${id}`)
  return asString ? draft : draft ? JSON.parse(draft, dateReviver) : null
}

export const saveDraft = (id: GQL_ID | undefined, draft: TextMaterialFormState) => {
  localStorage.setItem(`${TEXT_MATERIAL_STORAGE_KEY}-${id}`, JSON.stringify(draft))
}

export const clearDraft = (id: GQL_ID | undefined) => {
  localStorage.removeItem(`${TEXT_MATERIAL_STORAGE_KEY}-${id}`)
}
